<template>
  <div class="mb-4">
    <p class="title">{{ title }}</p>
    <v-radio-group
      v-if="question.type === 'SingleChoiceQuestionExecution'"
      v-model="selectedAnswer"
      column
      hide-details
      @change="changed"
    >
      <v-radio
        v-for="answer in question.answers"
        :key="answer.id"
        :disabled="elementFinished"
        :label="answer.text"
        :value="answer.id"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    elementFinished: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      selectedAnswer: this.question.selectedAnswerId
    };
  },
  computed: {
    title() {
      return `${this.index + 1}. ${this.question.text}`;
    }
  },
  methods: {
    changed(ev) {
      this.$emit('questionAnswered', {
        questionId: this.question.id,
        answerId: ev
      });
    }
  }
};
</script>
